import { Action } from '@ngrx/store';
import {IUsedAiCredits} from "../reducers/used-ai-credits.reducer";

// Action types
export const LOAD_USED_AI_CREDITS = '[Used AI Credits] Load Used AI Credits';
export const LOAD_USED_AI_CREDITS_SUCCESS = '[Used AI Credits] Load Used AI Credits Success';
export const LOAD_USED_AI_CREDITS_FAILURE = '[Used AI Credits] Load Used AI Credits Failure';

// Load action
export class LoadUsedAiCredits implements Action {
  readonly type = LOAD_USED_AI_CREDITS;
  constructor() {
  } // no payload
}

// Success action
export class LoadUsedAiCreditsSuccess implements Action {
  readonly type = LOAD_USED_AI_CREDITS_SUCCESS;
  constructor(public payload: { credits: IUsedAiCredits }) {}
}

// Failure action
export class LoadUsedAiCreditsFailure implements Action {
  readonly type = LOAD_USED_AI_CREDITS_FAILURE;
  constructor(public payload: { message: string }) {}
}

// Union type
export type UsedAiCreditsActions =
  | LoadUsedAiCredits
  | LoadUsedAiCreditsSuccess
  | LoadUsedAiCreditsFailure;
